import { isEnum, isNotEmpty, isString } from 'class-validator';
import { CallStatuses, CallTypes } from '@entities/call';
import type {
  RingIncomingCallRequest,
  RingIncomingCallValidator,
} from '@usecases/ring-incoming-call.usecase';
import type { UsecaseErrors } from '@usecases/usecase-errors';
import type { ValidationSchema } from '@main/validators/validation-schema';

export class RingIncomingCallValidatorImpl
  implements RingIncomingCallValidator
{
  private schema: ValidationSchema;

  constructor() {
    this.schema = {
      id: [
        [isString, 'is not string'],
        [isNotEmpty, 'is empty'],
      ],
      from: [
        [isString, 'is not string'],
        [isNotEmpty, 'is empty'],
      ],
      to: [
        [isString, 'is not string'],
        [isNotEmpty, 'is empty'],
      ],
      status: [
        [isNotEmpty, 'is empty'],
        [
          (val: never) => isEnum(val, CallStatuses),
          'is not a valid call status',
        ],
      ],
      type: [
        [isNotEmpty, 'is empty'],
        [(val: never) => isEnum(val, CallTypes), 'is not a valid call status'],
      ],
    };
  }

  async validate(
    call: RingIncomingCallRequest,
  ): Promise<void | Partial<UsecaseErrors<RingIncomingCallRequest>>> {
    return Object.keys(this.schema)
      .map((key) => {
        const elm = (<never>call)[key];
        const elmValidationSchema = this.schema[key] || [];

        const errs = elmValidationSchema
          .map((pair) => {
            const [validator, errMsg] = pair;
            return validator(elm) ? '' : errMsg;
          })
          .filter((msg) => !!msg)
          .map((msg) => ({ [key]: msg }));

        return errs.length ? errs[0] : undefined;
      })
      .filter((err) => !!err)[0];
  }
}
